import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import fadedQuestionMark from "~/public/static/images/svg/fadedQuestionMark.svg"

const BackgroundImageLayerOne = styled.div`
  background-image: url(${fadedQuestionMark});
  background-repeat: no-repeat;
  background-position: ${props => props.large ? '0px 20px' : '0px -30px'};
`

const BackgroundImageLayerTwo = styled.div`
  background-image: url(${fadedQuestionMark});
  background-repeat: no-repeat;
  background-position: ${props => props.large ? '100% 90%' : '100% 120%'};
`

const BackgroundQuestionMarks = ({ children, large }) => {
  return (
    <BackgroundImageLayerOne large={large}>
      <BackgroundImageLayerTwo large={large}>
        {children}
      </BackgroundImageLayerTwo>
    </BackgroundImageLayerOne>
  )
}

BackgroundQuestionMarks.defaultProps = {
  large: false
}

BackgroundQuestionMarks.propTypes = {
  large: PropTypes.bool
}

export default BackgroundQuestionMarks
